import { render, staticRenderFns } from "./FormContainer.vue?vue&type=template&id=c710d73e&"
import script from "./FormContainer.vue?vue&type=script&lang=js&"
export * from "./FormContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports